export enum FormQuestionType {
  TEXT = 'TEXT',
  CHOICE = 'CHOICE',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  RATING = 'RATING',
}

export interface FormOption {
  id: string;
  label: string;
  formOptionId?: number;
}

export interface FormQuestion {
  questionId: string;
  formQuestionId?: number;
  type: FormQuestionType;
  label: string;
  mandatory: boolean;
  options?: FormOption[];
  meta?: {
    maxAnswers?: number;
    min?: number;
    max?: number;
    scale?: number;
  } | null;
}

export interface UserSummary {
  id: number;
  userId?: number;
  firstName: string;
  lastName: string;
  picture?: string;
}

export interface FormResponseAnswer {
  formResponseAnswerId?: number;
  questionId: string | number;
  optionId?: string | number | null;
  text?: string | null;
  response?: string | null;
}

export interface FormResponse {
  responseId?: string;
  formResponseId?: number;
  id?: string;
  userId?: number;
  user: UserSummary;
  answers?: FormResponseAnswer[];
  questionId?: string;
  response?: string;
  createdAt: string;
}

export interface Form {
  id: string;
  communityId: string;
  title: string;
  description?: string;
  deadline?: string | null;
  questions: FormQuestion[];
  responses: FormResponse[];
  createdBy: UserSummary;
  createdAt: string;
  resultsVisibility?: 'PUBLIC' | 'PRIVATE' | 'ADMIN_ONLY';
  participants?: Array<{ dashboardMemberId: number; type: string; userId?: number }>;
  _count?: { responses?: number; questions?: number };
  responsesHidden?: boolean;
}
